export default __webpack_public_path__ + "static/media/004-A-banque.6a2e9a82.svg";